import { persistReducer } from 'redux-persist'
import { Action } from '@reduxjs/toolkit'
import storage from 'redux-persist/lib/storage'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  GetExecuteSqlTableData: '[GetExecuteSqlTableData] Action',
  SetExecuteSqlData: '[SetExecuteSqlData] Action',
  GetExecuteSqlTranslateData: '[GetExecuteSqlTranslateData] Action',
}

const initialExecuteSqlState: IExecuteSqlState = {
  executeSqlColumnList: [],
  executeSqlColumnValues: [],
  executeSqlDefinitions: [],
  executeSqlDe: [],
  executeSqlEn: []
}

export interface IExecuteSqlState {
  executeSqlColumnValues: [],
  executeSqlColumnList: [],
  executeSqlDefinitions: [],
  executeSqlDe: [],
  executeSqlEn: []
}

export const reducer = persistReducer(
  { storage, key: 'portal-ExecuteSql', whitelist:  [ ] },
  (state: IExecuteSqlState = initialExecuteSqlState, action: any) => {
    switch (action.type) {
      case actionTypes.GetExecuteSqlTableData: {
        const executeSqlColumnValues = action.payload.data.ExecuteSql;
        let headers = JSON.parse(action.payload.data.headers);
        let executeSqlDefinitions = JSON.parse(action.payload.data.definitions);
        let executeSqlColumnList: any = [];
       
        headers.forEach((element: any) => {
          let newElement: any = [...Object.values(element)]
          executeSqlColumnList.push(newElement[0]);
        });
        return { ...state, executeSqlColumnList, executeSqlColumnValues, executeSqlDefinitions};
      }
    
      case actionTypes.SetExecuteSqlData: {
        const executeSqlColumnValues = action.payload.data;
        return { ...state, executeSqlColumnValues };
      }

      case actionTypes.GetExecuteSqlTranslateData: {
        const executeSqlDe = JSON.parse(action.payload.data.de);
        const executeSqlEn = JSON.parse(action.payload.data.en);
        return { ...state, executeSqlDe, executeSqlEn };
      }
      
      default:
        return state
    }
  }
)

export const actions = {
  getExecuteSqlTableData: (data: any) => ({ type: actionTypes.GetExecuteSqlTableData, payload: { data } }),
  getTranslateData: (data: any) => ({ type: actionTypes.GetExecuteSqlTranslateData, payload: { data } }),
  setExecuteSqlData: (data: any) => ({ type: actionTypes.SetExecuteSqlData, payload: { data } }),
  store: () => ({ type: "def" }),
}

export function* saga() {

}
